import { LearningPathStatus } from 'enum/learningPathStatus.enum'
import { ILearningProgram } from 'interfaces/roles'
import { QuestionTypes } from 'enum/questionTypes.enum'
import {
  IQuestionBankData,
  IQuestionBankQuestion,
  IQuestionBankSection,
  IQuestionBankState,
} from 'interfaces/questionBank'
import i18n from 'i18n'

export const QUESTION_BANK_UNTITLED_SECTION_KEY =
  'administration.blocks.type.questionBankV2.sections.untitled'

export const getUntitledSectionName = (): string =>
  i18n.t(QUESTION_BANK_UNTITLED_SECTION_KEY)

export const createEmptyQuestionBankSection = (
  order = 0
): IQuestionBankSection => ({
  name: getUntitledSectionName(),
  description: '',
  randomOrder: false,
  randomQuestionsToDisplay: 1,
  scoreForEachQuestion: 1,
  order,
  questions: [],
})

export const createInitialQuestionBankData = (): IQuestionBankData => ({
  name: '',
  description: '',
  sections: [createEmptyQuestionBankSection()],
  minimumPassingScore: 0,
  mandatory: false,
  approvalRequired: false,
  showResults: false,
  multipleRetries: false,
  maxRetries: 1,
})

export const initialLearningPathConfiguration = {
  id: 0,
  name: '',
  description: '',
  image: null,
  profiles: [],
  state: LearningPathStatus.draft,
}

export const initialLearningPathContent = {
  learningPaths: [0],
  collections: [
    {
      id: 0,
      name: 'Colección de cursos 1',
      order: 0,
      relatedCourses: [],
    },
  ],
}

export const emptyLearningProgram: ILearningProgram = {
  id: 0,
  name: '',
  courses: 0,
  state: LearningPathStatus.draft,
}

export const initialQuestionBankState: IQuestionBankState = {
  stage: 0,
  data: createInitialQuestionBankData(),
  loading: false,
  updated: false,
  pendingPrefill: null,
}

export const initialQuestionBankQuestion: IQuestionBankQuestion = {
  name: '',
  code: '',
  score: 1,
  order: 0,
  multimediaContent: null,
  type: QuestionTypes.likert,
  showAnswerExplanation: false,
  answerExplanation: '',
  answers: [
    {
      name: '',
      correct: false,
      order: 0,
    },
  ],
}
